import { alpha, styled } from '@mui/material';
import { CollapseCard } from '@totalsoft/rocket-ui';
import { withPropsExclusion } from 'utils/functions';

export const DetailsCollapseCard = styled(CollapseCard)(({ theme }) => ({
  '& .MuiCardHeader-root': {
    paddingBlock: theme.spacing(1.25),
    cursor: 'pointer'
  },
  '& .MuiCardHeader-title > h6': {
    fontSize: '16px'
  }
}));

export const EventCollapseCard = styled(
  DetailsCollapseCard,
  withPropsExclusion('selected')
)(({ theme, selected }) => ({
  '& .MuiCardHeader-root': {
    ...(selected && {
      backgroundColor: alpha(theme.palette.primary.main, 0.05)
    })
  },
  '&:hover .MuiCardHeader-root': {
    backgroundColor: selected ? alpha(theme.palette.primary.main, 0.08) : theme.palette.grey[100]
  }
}));
